import { render, staticRenderFns } from "./ModuleDocuments.vue?vue&type=template&id=72bf2385&"
import script from "./ModuleDocuments.vue?vue&type=script&lang=js&"
export * from "./ModuleDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports